import Tires from './Tires';

export default function Products() {
  return <Tires viewOnly="manage" />;
}
